export default __webpack_public_path__ + "static/media/Test.4b6d6f1a.png";